<template>
    <div class="flex flex-col text-left">
        <span>This text is a brief description of the features that are present in the shell (version 0.1, 10 November 2021).</span>
        <br />
        <span>This is Edition 0.1, last updated 10 November 2021, of 'Reference Manual', for Version 0.1.</span>
        <span>This contains features that appear in other popular shells.  Some of the shells that have
        borrowed concepts are the Bourne Shell ('sh'), the Korn Shell
        ('ksh'), and the C-shell ('csh' and its successor, 'tcsh').</span>
        <br />
        <span>The manual that is nowhere to be found is meant as a brief introduction to features found in whatever this is.
        The manual page should never be used as the definitive reference
        on shell behavior.</span>
        <br />
    </div>
</template>
